export const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const PROTECTED_SUBSCRIPTION_PLAN_SLUGS = ['trial', 'legacy'] as const;

export type ProtectedSubscriptionPlanSlug = (typeof PROTECTED_SUBSCRIPTION_PLAN_SLUGS)[number];

export const isProtectedSubscriptionPlanSlug = (slug: string): boolean =>
  PROTECTED_SUBSCRIPTION_PLAN_SLUGS.includes(slug as ProtectedSubscriptionPlanSlug);

export function validateSubscriptionPlanSlug(slug: string): string | null {
  const normalized = slug.trim().toLowerCase();
  if (!normalized) return 'Slug é obrigatório';
  if (normalized.length > 64) return 'Slug muito longo';
  if (!SLUG_REGEX.test(normalized)) {
    return 'Use apenas letras minúsculas, números e hífen';
  }
  return null;
}
